(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnt-chapter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setUp(root) {
      if (!root || root.dataset.tntReady) return;
      root.dataset.tntReady = 'true';

      var rail = root.querySelector('[data-tnt-rail]');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tnt-tab]'));
      var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
      var none = root.querySelector('[data-tnt-none]');

      function show(tag) {
        var shown = 0;
        root.querySelectorAll('[data-tnt-rail] [data-tnt-card]').forEach(function (card) {
          var tags = ' ' + (card.getAttribute('data-tags') || '') + ' ';
          var match = tag === 'all' || tags.indexOf(' ' + tag + ' ') > -1;
          var visible = match && shown < limit;
          card.hidden = !visible;
          if (visible) shown += 1;
        });
        if (none) none.hidden = shown > 0;
        if (rail) rail.scrollLeft = 0;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (other) {
            other.setAttribute('aria-pressed', other === tab ? 'true' : 'false');
          });
          show(tab.getAttribute('data-tnt-tab'));
        });
      });

      function step(direction) {
        if (!rail) return;
        rail.scrollBy({ left: direction * rail.clientWidth * 0.85, behavior: 'smooth' });
      }

      var prev = root.querySelector('[data-tnt-prev]');
      var next = root.querySelector('[data-tnt-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      if (tabs.length) show('all');
    }

    function setUpAll() {
      document.querySelectorAll('[data-tnt-chapter]').forEach(setUp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setUpAll);
    } else {
      setUpAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      setUp(event.target.querySelector('[data-tnt-chapter]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnt-motion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tnt-play]');
    if (!button) return;
    const video = button.querySelector('video');
    if (!video) return;
    document.querySelectorAll('[data-tnt-play] video').forEach((other) => {
      if (other !== video && !other.paused) {
        other.pause();
        other.closest('[data-tnt-play]').classList.remove('is-playing');
      }
    });
    if (video.paused) {
      video.play();
      button.classList.add('is-playing');
      button.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      button.classList.remove('is-playing');
      button.setAttribute('aria-label', 'Play video');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
